import React from 'react';
import {CrossHairCursor} from "react-stockcharts/lib/coordinates";

export default function () {
  return (
    <CrossHairCursor stroke="#ffffff"/>
  );
}
